(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eg-custom-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    const measure = () => {
      // Only while unlocked: a locked page has no scrollbar to measure.
      if (root.hasAttribute('scroll-lock') || document.body.style.position === 'fixed') return;
      root.style.setProperty('--eg-scrollbar-width', `${window.innerWidth - root.clientWidth}px`);
    };
    // Observes the root so a scrollbar that appears as content grows is caught too.
    new ResizeObserver(measure).observe(root);
  })();
  } catch(e) { console.error(e); }
})();

})();
